module.exports = __webpack_public_path__ + "static/img/bxcp_m_banner2.5104662.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bxcp_m_banner2.jpg
// module id = n5Xx
// module chunks = 1